import { Box, useTheme } from '@mui/material'
import { grey } from '@mui/material/colors'
import Loading from 'react-loading'

export default function LoadingScreen() {

    const theme = useTheme()
    
    return (
        <Box
            sx={{
                width: "100%",
                height: "100%",
                backgroundColor: theme.palette.primary.main,
                display: "flex",
                justifyContent: "center",
                alignItems: 'center'
            }}
        >

            <Loading 
                type='balls'
                color={grey['200']}
                height="3rem"
                width="3rem"
            />

        </Box>
    )
}
